var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillLevelDonutQuarter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skill_level_donut_quarter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.06298 11.2178C9.87204 11.2178 11.3386 9.75132 11.3386 7.94226C11.3386 6.1332 9.87204 4.66667 8.06298 4.66667C6.25393 4.66667 4.78739 6.1332 4.78739 7.94226C4.78739 9.75132 6.25393 11.2178 8.06298 11.2178Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 4",
    d: "M8 0C10.1217 2.53014e-08 12.1566 0.842854 13.6569 2.34314C15.1571 3.84344 16 5.87827 16 8L11.336 8C11.336 7.11524 10.9845 6.26671 10.3589 5.64109C9.73329 5.01547 8.88476 4.664 8 4.664L8 0Z",
    fill: "#164A3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLevelDonutQuarter);
export default __webpack_public_path__ + "static/media/skill_level_donut_quarter.b0e6753a7864bd0e6d46eeee92d7614c.svg";
export { ForwardRef as ReactComponent };